// Gender options a family may pick when self-adding a member (D8 follow-up).
// Values MUST match the CRM Gender enum strings exactly (stored verbatim).
export const GENDER_OPTIONS: { value: string; label: string }[] = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'NonBinary', label: 'Non-binary' },
  { value: 'PreferNotToSay', label: 'Prefer not to say' },
  { value: 'Other', label: 'Other' },
];

const GENDER_SET = new Set(GENDER_OPTIONS.map((g) => g.value));
export function isGender(value: string): boolean {
  return GENDER_SET.has(value);
}
